import { Box, Typography } from "@mui/material";
import NewEditIcon from "../Icons/NewEditIcon";
import { BookingReasonsIcon, DoctorVisitIcon, DropOffIcon, ExpressServiceIcon } from "../Icons";
import UrgentVisitIcon from "../Icons/UrgentVisitIcon";
import React, { useState } from "react";
import { ReasonForVisitContainerStyled } from "../../shared/containers/BookingReviewContainer/BookingReviewStyle";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useBookingAppointmentTypeStore, useBookingReasonsNavigation } from "../../hooks";
import { ASSIGNED_BOOKING_TYPE, CREATE_BOOKING_TYPE } from "../../config/params";
import { userActivityLogger } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { IAppointmentCreateResponse } from "../../services/create-appointment-v2/create-appointment-v2.interface";
interface IBookingReviewDetails{
  setActiveStep?: (val: number) => void;
  modal: "BookingReview" | "BookingConfirmation" | "AppointmentReview";
  isExpressVisit?: boolean;
  setReasonUpdatePetIndex?: (index: number) => void;
  setSelectedReasonType?: (value: any) => void;
  setSelectedReasons?: (value: any) => void;
}

const BookingReviewDetails = ({
  setActiveStep,
  modal,
  isExpressVisit= false,
  setSelectedReasonType,
  setSelectedReasons,
  setReasonUpdatePetIndex }: IBookingReviewDetails) => {
  const { appointmentDetails, appointmentsResponse, appointmentsRescheduleResponse, selectedPets, reasonForVisit,
    setReasonForVisit } = useAppointmentStore();
  // eslint-disable-next-line no-unused-vars
  const [visit, setVisit] =
  useState<IAppointmentCreateResponse | null>(appointmentsResponse || appointmentsRescheduleResponse);
  const { appointmentTypeIndicator, bookingAppointmentType } = useBookingAppointmentTypeStore();
  const { setDefaultNavigationValues }=useBookingReasonsNavigation();
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toLocaleUpperCase() + string.substring(1);
  };

  const logMixPanelEvent = (appointmentType: string) => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_EDIT_DETAILS,
      { pet_name: selectedPets.map((pet) => pet.name).join(","),
        type: "edit_reason",
        appt_type: appointmentType,
      });
  };
  const handleEditReason = () => {
    if (isExpressVisit) {
      setReasonUpdatePetIndex && setReasonUpdatePetIndex(1);
      setSelectedReasonType && setSelectedReasonType("");
      setSelectedReasons && setSelectedReasons([]);
      setReasonForVisit({});
      setActiveStep && setActiveStep(1);
      logMixPanelEvent("express_visit");
    } else {
      setDefaultNavigationValues();
      setActiveStep && setActiveStep(2);
      const appointmentType = bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
        "drop_off" : "in_room_visit";

      logMixPanelEvent(appointmentType);
    }
  };
  const getReasonTypeIcon = ()=>{
    if (modal === "BookingConfirmation") {
      switch (visit?.appointmentCreateType) {
      case ASSIGNED_BOOKING_TYPE.DROPOFF_BOOKING:
        return <DropOffIcon width={17} height={17} />;
      case ASSIGNED_BOOKING_TYPE.EXPRESS_BOOKING:
        return <ExpressServiceIcon width={17} height={17} />;
      case ASSIGNED_BOOKING_TYPE.URGENT_BOOKING:
        return <UrgentVisitIcon width={17} height={17} />;
      default:
        return <DoctorVisitIcon width={17} height={17} />;
      }
    } else {
      switch (appointmentDetails?.appointmentCreateType) {
      case ASSIGNED_BOOKING_TYPE.DROPOFF_BOOKING:
        return <DropOffIcon width={17} height={17} />;
      case ASSIGNED_BOOKING_TYPE.EXPRESS_BOOKING:
        return <ExpressServiceIcon width={17} height={17} />;
      case ASSIGNED_BOOKING_TYPE.URGENT_BOOKING:
        return <UrgentVisitIcon width={17} height={17} />;
      default:
        return <DoctorVisitIcon width={17} height={17} />;
      }
    }
  };

  const getReasonTypeText = (bookingTypeIndicator: Number)=>{
    switch (bookingTypeIndicator) {
    case ASSIGNED_BOOKING_TYPE.DROPOFF_BOOKING:
      return "Drop-Off Visit: ";
    case ASSIGNED_BOOKING_TYPE.EXPRESS_BOOKING:
      return "Express Services: ";
    case ASSIGNED_BOOKING_TYPE.URGENT_BOOKING:
      return "Urgent Doctor Visit: ";
    default:
      return "Doctor Visit: ";
    }
  };

  const getFormattedReasonsString = (bookingReasons: string, reasonTypeText?: string) => {
    const formattedHTML: JSX.Element[] = [];
    const match = bookingReasons.match(/Description:(.*?),reasons:(.*)/);

    const description = match?.[1] ?? "";
    const reasons = match?.[2] ?? "";

    if (description.length > 1) {
      formattedHTML.push(
        <React.Fragment>
          <div className="flex flex-col gap-1 max-w-full overflow-hidden">
            <div className="flex flex-col gap-1">
              <span className="font-semibold capitalize text-base">
                {reasonTypeText ? reasonTypeText : "Express Services: "}
              </span>
              <span className="font-normal text-base">
                {reasons}
              </span>
            </div>
            <div className="font-medium text-xs text-gray-1 break-words max-h-40 overflow-y-auto">
              {description}
            </div>
          </div>
        </React.Fragment>,
      );
    } else {
      formattedHTML.push(
        <React.Fragment >
          <div className="flex flex-col gap-1">
            <span className="text-base font-semibold capitalize">
              {reasonTypeText ? reasonTypeText : "Express Services: "}
            </span>
            <span className="font-normal text-base">
              {bookingReasons}
            </span>
          </div>
        </React.Fragment>,
      );
    }

    return formattedHTML;
  };


  return (
    <ReasonForVisitContainerStyled className={`!w-full ${modal !== "BookingReview" && "!border-none"}
     ${modal==="BookingConfirmation" || modal==="AppointmentReview" ? undefined: "!p-3"}`}>
      <div className="min-w-[25px]">
        {modal !== "BookingReview" ?
          <div className="h-fit w-fit flex items-center justify-center bg-taupe-4 rounded-full p-1">
            {getReasonTypeIcon()}
          </div>:
          <BookingReasonsIcon width={25} height={25} color={"#262626"} />
        }
      </div>
      <Box className="childContainer">
        {modal === "BookingReview" && selectedPets.map((info, index) => (
          <Box className="flex flex-col w-full grow mb-1" key={index}>
            {selectedPets.length>1 &&
            <Typography variant="h4" color="#908E8D">
              {capitalizeFirstLetter(info.name)}
            </Typography>}
            <Typography variant="h4" className="!font-semibold">
              {
                getFormattedReasonsString(reasonForVisit[info.id].reasons,
                  getReasonTypeText(appointmentTypeIndicator))
              }
            </Typography>
          </Box>
        ))}
        {modal === "BookingConfirmation" && visit && (
          visit?.pets.length > 1 ? (
            visit?.pets?.map((pet) => (
              <Box className="flex flex-col gap-1" key={pet.id}>
                <Typography variant="body1" className="!text-gray-1">{capitalizeFirstLetter(pet.name)}</Typography>
                <Typography className="!text-base !font-semibold">
                  {
                    getFormattedReasonsString(pet?.reasonForVisit,
                      getReasonTypeText(pet?.appointmentCreateType ?
                        pet?.appointmentCreateType : visit?.appointmentCreateType))
                  }
                </Typography>
              </Box>
            ))
          ) : (
            <div className="flex flex-col">
              <Typography className="!text-base !font-semibold">
                {
                  getFormattedReasonsString(
                    visit?.pets?.[0].reasonForVisit,
                    getReasonTypeText(visit?.appointmentCreateType))
                }
              </Typography>
            </div>
          )
        )}

        {modal === "AppointmentReview" && appointmentDetails &&(
          <Box className="max-w-full">
            <Box className="flex flex-col">
              <Typography variant="h4" className="!capitalize " fontWeight={600}>
                {getFormattedReasonsString(appointmentDetails?.reasonsForVisit,
                  getReasonTypeText(appointmentDetails?.appointmentCreateType))}
              </Typography>
            </Box>
          </Box>
        ) }

      </Box>
      {setActiveStep && modal === "BookingReview" && <Box
        className="grow flex justify-end items-center mt-2 cursor-pointer"
        onClick={handleEditReason}
      >
        <NewEditIcon width={18} height={18} />
      </Box>}
    </ReasonForVisitContainerStyled>
  );
};

export default BookingReviewDetails;
